import algoliasearch from "algoliasearch/lite"
import { default as React, useState, useMemo, useEffect, useRef } from "react"
import { kebabCase, orderBy } from "lodash"
import {
  InstantSearch,
  Pagination,
  RefinementList,
  ClearRefinements,
  ScrollTo,
  CurrentRefinements,
  Configure,
} from "react-instantsearch-dom"
import { DEBOUNCE_TIME, createURL, searchStateToUrl, urlToSearchState } from "./utils"
import { navigate } from "gatsby"
import SearchBox from "./search-box"
import SearchResult from "./search-result"
import "../../styles/search.css"
import { Popover } from "@headlessui/react"
import Chevron from "../icons/chevron"



export default function Search({ indices, props, location }) {
  const { heading } = props

  const searchClient = useMemo(
    () =>
      algoliasearch(
        "TQGFISJST2",
        "be28b76dd1c0804224dfd545f25c251f",
      ),
    []
  )

  const [searchState, setSearchState] = useState(urlToSearchState(location));
  const debouncedSetStateRef = useRef(null);

  function onSearchStateChange(updatedSearchState) {
    clearTimeout(debouncedSetStateRef.current);

    debouncedSetStateRef.current = setTimeout(() => {
      navigate(searchStateToUrl(updatedSearchState));
    }, DEBOUNCE_TIME);
    setSearchState(updatedSearchState);
  }

  useEffect(() => {
    setSearchState(urlToSearchState(location));
  }, [location]);

  return (
    <section className="container" key={indices}>
      <div>
        <InstantSearch
          searchClient={searchClient}
          indexName={indices[0].name}
          // onSearchStateChange={({ query }) => setQuery(query)}
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
          createURL={createURL}
        >
          <div className={`relative pb-12 search-${indices[0]?.name}`}>
            {heading ? <h2 id={kebabCase(heading)} className="">{heading}</h2> : null}
            <div className="relative">
              <SearchFilters indices={indices}
              />
            </div>

            <div className="mt-6">

              <ScrollTo>
                <SearchResult
                  indices={indices}
                />
              </ScrollTo>
              <Pagination className="pt-6" />
            </div>

          </div>
        </InstantSearch>
      </div>
    </section>
  )
}

function SearchFilters({ indices }) {
  const filters = indices[0].name === "Events" ? [
    "Venue",
    "Month"
  ] : null
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return (
    <div className="">
      <div className="sm:flex justify-between items-start sm:space-x-4 mt-6">
        <div className="text-sm w-full">

          <SearchBox />
          <CurrentRefinements className="mb-2 " />
          <ClearRefinements className="mb-2 " />
          {indices[0].name === "Events" ? <Configure
            filters={`event_timestamp > ${Math.floor(d.getTime() / 1000)}`}
          /> : null}

        </div>
        <div className="flex space-x-4 relative">
          {filters?.map((filter, index) => (
            <Popover
              as="div"
              key={filter}
              className="sm:relative"
            >
              {({ open }) => (
                <>
                  <Popover.Button className="btn-sm btn-primary shadow-spread">
                    <span className="mr-2">{filter}</span>
                    <Chevron className={`w-3 h-3 ${open ? "-rotate-90" : "rotate-90"}`} />
                  </Popover.Button>

                  <Popover.Panel
                    className={`dropdown ${index === 0 ? "dropdown-left-xs-only" : ""} px-4 p-2 mt-4 rounded w-60 left-0 sm:left-auto sm:right-0 absolute bg-white shadow-spread ${open
                      ? "z-10"
                      : "h-0 pointer-events-none -z-10 invisible"
                      }`}
                    static
                  >
                    <div className="">
                      <RefinementList
                        className="my-1"
                        attribute={filter}
                        limit={100}
                        transformItems={items => orderBy(items, "label", "asc")}
                      />
                    </div>
                  </Popover.Panel>
                </>
              )}
            </Popover>
          ))}

        </div>
      </div>
    </div>
  )
}
